<template>
	<div class="site-footer">
		<div class="site-footer__content">
			<ul class="site-footer__links">
				<li><a href="https://www.dtcc.com/annuals/2024/files/DTCC-Annual-Report-2024-Print.pdf" target="_blank">Download the report</a></li>
				<li><a href="https://www.dtcc.com/" target="_blank">Dtcc.com</a></li>
				<li><a href="https://www.dtcc.com/terms" target="_blank">terms of use</a></li>
				<li><a href="https://www.dtcc.com/privacy" target="_blank">privacy policy</a></li>
			</ul>

			<ul class="site-footer__social">
				<li><a href="https://www.linkedin.com/company/dtcc" target="_blank"><img src="@/assets/icons/li.svg" alt="linked in icon" /></a></li>
				<li><a href="https://www.instagram.com/the_dtcc/" target="_blank"><img src="@/assets/icons/ig.svg" alt="instagram icon" /></a></li>
				<li><a href="https://twitter.com/the_dtcc" target="_blank"><img src="@/assets/icons/ex.svg" alt="ex icon" /></a></li>
				<li><a href="https://www.facebook.com/TheDTCC" target="_blank"><img src="@/assets/icons/fb.svg" alt="facebook icon" /></a></li>
				<li><a href="https://www.youtube.com/c/thedtcc1973" target="_blank"><img src="@/assets/icons/yt.svg" alt="youtube icon" /></a></li>
				<li><a href="http://www.dtcc.com/rss-feeds" target="_blank"><img src="@/assets/icons/rss.svg" alt="rss icon" /></a></li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SiteFooter',
}
</script>

<style scoped lang="scss">
.site-footer {
	--gap: 1.75rem;
	--gutter: 3.75rem;
	--radius: var(--border-radius);

	@include modules.media-query('phone') {
		--gap: 1.25rem;
		--gutter: 1.25rem;
		--radius: var(--border-radius--phone);
	}

	max-width: var(--max-width);
	margin-left: auto;
	margin-right: auto;
	margin-top: var(--gutter);
	padding: 0 var(--gutter);
	position: static;
	width: 100%;

	&__content {
		padding:  var(--gutter);
		background-color: var(--color--dark-green);
		border-top-left-radius: var(--border-radius);
		border-top-right-radius: var(--border-radius);
		border: 1px solid var(--color--cream);
		border-bottom: 0;

		@include modules.media-query('phone') {
			--gap: 1.25rem;
			--gutter: 1.25rem;
			--radius: var(--border-radius--phone);

			padding: var(--border-radius--phone);
		}
	}

	&__links {
		list-style: none;
		display: flex;
		padding: 0;

		@include modules.media-query('phone') {
			flex-direction: column;
		}

		a {
			color: var(--color--cream);
			text-decoration: none;
			text-transform: uppercase;
			font-size: var(--font-footer-link--size);
			line-height: var(--font-footer-link--height);
			font-weight: var(--font-footer-link--weight);
			margin-right: 2rem;
			transition: var(--link-text-hover);
			display: block;

			@include modules.media-query('phone') {
				font-size: var(--font-footer-link--size--mobile);
				margin-right: 0;
				margin-bottom: 1rem;
			}

			&:hover {
				color: var(--color--gold);
			}
		}
	}

	&__social {
		list-style: none;
		display: grid;
		grid-template-columns: repeat(6, min-content);
		// flex-wrap: wrap;
		margin-top: var(--gutter);
		padding: 0;

		@include modules.media-query('phone') {
			grid-template-columns: repeat(3, min-content);
		}

		li {
			margin: 0 2rem 1rem 0;
		}

	}


}
</style>
